import controller from './manage-contacts-delete-dialog.controller';

export default {
  controller,
  template: require('./manage-contacts-delete-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/manage-contacts-delete-dialog/manage-contacts-delete-dialog.component.ts